/* P.S. additions on top of gp-sg.js: hero sound toggle (gp-sg handles autoplay/slide-over/pills) */
(function () {
  var video = document.getElementById('psx-hero-video');
  var soundBtn = document.getElementById('psx-hero-sound');
  if (video && soundBtn) {
    soundBtn.addEventListener('click', function () {
      video.muted = !video.muted;
      if (!video.muted) video.play().catch(function () {});
      soundBtn.setAttribute('aria-pressed', String(!video.muted));
      soundBtn.textContent = video.muted ? 'Sound on' : 'Sound off';
    });
  }
})();
